import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
  constituencyListData = null,
}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `Assam Election 2026 Date: असम विधानसभा चुनाव की तारीख़, चरणवार वोटिंग और रिजल्ट शेड्यूल - NewsTak`,
    description: `Assam Chunav 2026 Schedule: जानें असम विधानसभा चुनाव 2026 की वोटिंग डेट, चरणवार मतदान का पूरा शेड्यूल, नतीजे कब आएंगे और नामांकन की तारीख़ें, पढ़ें Assam Election 2026 से जुड़ी हर अपडेट सिर्फ NewsTak पर.`,
    keywords: `Assam election 2026 date, Assam election schedule 2026, Assam vidhan sabha chunav 2026, Assam voting date 2026, Assam election result date, Assam chunav phase 1 2026, Assam chunav phase 2 2026, Assam election news 2026, असम चुनाव 2026 तारीख, असम विधानसभा चुनाव शेड्यूल`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/schedule`}
         
          isMobileDevice={isMobileDevice}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="assam_election"
          stateName={"Assam"} //"Delhi"
          stateHindi={"असम"}
          metaData={metaData}
          constituencyListData={constituencyListData}
          staticContent="असम की 126 विधानसभा सीटों पर एक ही चरण में मतदान होगा. असम विधानसभा चुनाव के लिए मतदान की तारीख 9 अप्रैल है, वहीं वोटों की गिनती 4 मई को होगी. परिणाम भी 4 मई को आ सकते है. चुनाव की तारीखों के ऐलान के बाद 16 मार्च को गजट नोटिफिकेशन जारी कर दिया गया है. उम्मीदवार 23 मार्च तक नामांकन दाखिल कर सकेंगे और फिर 24 मार्च को इसकी स्क्रूटनी होगी. वहीं 26 मार्च तक उम्मीदवार अपना नामांकन वापस ले सकते हैं."
          />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/schedule")[0];

  let electionCategory = url.split("/elections/")[1];
 
  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

 let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.assam_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
       ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        // faqData,
        constituencyListData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
